import { createClient, ExperimentSchemas } from 'laboratory-lib';
import PortalIdParser from 'PortalIdParser';
import experiments from '../../experiments.yaml';

export const LABORATORY_CLIENT_NAME = 'ui-addon-upgrades-laboratory-client';

export const laboratoryClient = createClient({
  name: LABORATORY_CLIENT_NAME,
  experiments: experiments as ExperimentSchemas,
  identifiers: {
    portalId: PortalIdParser.get(),
  },
});

export const logExposure = (
  ...args: Parameters<typeof laboratoryClient.logExposure>
) => laboratoryClient.logExposure(...args);
